<template>
  <div>
    <hg-dialog :title="title" :width="800" :height="400" :visible.sync="dialogVisible" @close="handleClose">
      <div class="special_Form">
        <el-form :model="data" :rules="rules" size="mini" ref="ruleForm" label-width="120px" class="add-box">
          <el-row :gutter="22">
            <el-col :span="11">
              <el-form-item label="用户名" prop="username">
                <el-input v-model="data.username" maxlength="50" placeholder="请输入用户名" :disabled="!isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="昵称" prop="nickName">
                <el-input v-model="data.nickName" maxlength="50" placeholder="请输入昵称" :disabled="!isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="11">
              <el-form-item label="密码" prop="password">
                <el-input v-model="data.password" type="password" maxlength="50" placeholder="请输入密码"
                          :disabled="!isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="性别" prop="sex">
                <el-select v-model="data.sex" :disabled="!isEdit" placeholder="请选择性别">
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="11">
              <el-form-item label="微信注册手机号" prop="phoneOne">
                <el-input v-model="data.phoneOne" maxlength="11" placeholder="请输入微信注册手机号"
                          :disabled="!isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="联系方式2" prop="phoneTwo">
                <el-input v-model="data.phoneTwo" maxlength="11" placeholder="请输入联系方式2" :disabled="!isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="11">
              <el-form-item label="身份证号">
                <el-input v-model="data.userId" maxlength="18" placeholder="请输入身份证号" :disabled="!isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="是否启用" prop="statu">
                <el-switch
                  v-model="statu"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :disabled="!isEdit"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="11">
              <el-form-item label="客户" prop="defaultDepart">
                <el-select v-model="data.defaultDepart" filterable placeholder="请选择客户" :disabled="!isEdit">
                  <el-option
                    v-for="item in departList"
                    :key="item.depCode"
                    :label="item.name"
                    :value="item.depCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="角色" prop="roleId">
                <el-select v-model="data.roleId" filterable placeholder="请选择角色" :disabled="!isEdit">
                  <el-option
                    v-for="item in roleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" style="width:100%;text-align: right">
        <el-button v-if="isEdit" type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button v-else type="primary" @click="edit" size="small" icon="el-hg-icon-edit">修 改</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
  import list from '../comm/list';
  import HgDialog from '@/components/dialog';

  export default {
    name: 'edit',
    components: {
      list,
      HgDialog
    },
    props: {
      oActiveItemId: {
        type: [String, Number]
      },
      allRoleList: {
        type: Array
      },
      show: {
        type: Boolean,
        default: false
      },
      title: {
        String,
        default: '客户人员详情'
      },
      isEdit: {
        String,
        default: false
      }
    },
    data() {
      return {
        dialogVisible: false,
        rules: {
          username: [{
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }, {max: 8, message: '最多不能超过8个字符', trigger: 'blur'}],
          nickName: [{
            required: true,
            message: '请输入昵称',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
          defaultDepart: [{
            required: true,
            message: '请选择客户',
            trigger: 'change'
          }],
          roleId: [{
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }],
          phoneOne: [
            {
              message: '请输入联系方式1',
              trigger: 'blur'
            },
            {
              pattern: this.$utils.regRule.phone,
              message: '联系方式格式不正确',
              trigger: 'blur'
            }
          ]
        },
        data: {
          username: '',
          nickName: '',
          password: '',
          sex: '1',
          phoneOne: '',
          phoneTwo: '',
          userId: '',
          sort: '',
          select: '',
          roleId: '',
          roleArr: [],
          defaultDepart: '',
          departId: '',
          updateFlg: 'update'
        },
        dataForm: {
          username: '',
          nickName: '',
          password: '',
          sex: '1',
          phoneOne: '',
          phoneTwo: '',
          userId: '',
          sort: '',
          select: '',
          roleId: '',
          defaultDepart: '',
          departId: '',
          updateFlg: 'update'
        },
        roleArr: [],
        departArr: [],
        defaultDepart: '',
        departList: [],
        roleList: [],
        statu: false
      };
    },
    methods: {
      edit() {
        this.$emit('update:isEdit', true);
        this.$emit('update:title', '用户编辑');
      },
      submit() {
        this.$refs['ruleForm'].validate(valid => {
          if (valid) {
            this.dataForm.id = this.data.id;
            this.dataForm.parentId = this.data.parentId;
            this.dataForm.departId = this.departArr.join();
            this.dataForm.name = this.data.name;
            this.dataForm.shortname = this.data.shortname;
            this.dataForm.phoneOne = this.data.phoneOne;
            this.dataForm.grade = this.data.grade;
            this.dataForm.phoneTwo = this.data.phoneTwo;
            this.dataForm.sort = this.data.sort;
            this.dataForm.select = this.data.select;
            this.dataForm.userId = this.data.userId;
            this.dataForm.username = this.data.username;
            this.dataForm.defaultDepart = this.data.defaultDepart;
            this.dataForm.roleId = this.data.roleId;
            this.dataForm.nickName = this.data.nickName;
            this.dataForm.password = this.data.password;
            this.dataForm.sex = this.data.sex;
            this.dataForm.status = this.statu ? 1 : 0;
            this.saveDepart();
          }
          else {
            return false;
          }
        });
      },
      toSelect(departId) {
        if (this.departArr.indexOf(departId) > -1) {
          this.departArr.splice(this.departArr.indexOf(departId), 1);
        }
        else {
          this.departArr.push(departId);
        }
      },
      defaultSelect(defaultDepart) {
        this.data.defaultDepart = defaultDepart;
      },
      async saveDepart() {
        const res = await this.$services.postJson({
          type: 'DEPARTMANGEMENT',
          url: 'saveUser',
          params: JSON.parse(JSON.stringify(this.dataForm))
        });
        if (res.code === '000') {
          this.$toaster.ok('保存成功');
          this.handleClose();
          this.$emit('refresh');
        }
        else {
          // this.$toaster.error(res.msg);
        }
      },
      handleClose() {
        this.$refs['ruleForm'].resetFields();
        this.dialogVisible = false;
        this.roleArr = [];
        this.$emit('close');
      },
      async getUserDetail() {
        const {bean} = await this.$services.post({
          type: 'DEPARTMANGEMENT',
          url: 'getUserDetail',
          params: {
            id: this.oActiveItemId
          }
        });
        this.data = bean;
        this.departArr = bean.departId.split(',')
        this.statu = this.data.status === 1 ? true : false;
        // this.$set(this.data, 'roleArr', this.data.roleId.split(','));
      },
      async getDepartList() {
        const {bean} = await this.$services.post({
          type: 'DEPARTMANGEMENT',
          url: 'getDepartList'
        });
        this.departList = bean;
      },
      async listGuestRole() {
        const {bean} = await this.$services.post({
          type: 'DEPARTMANGEMENT',
          url: 'listGuestRole'
        });
        this.roleList = bean;
      }
    },
    watch: {
      show(val) {
        if (val) {
          this.dialogVisible = true;
          this.getUserDetail();
          this.getDepartList();
          this.listGuestRole();
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .el-form-item__error {
    top: 78% !important;
    font-size: 10px !important;
    z-index: 10;
  }

  .special_Form {
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
      content: '*' !important;
    }
  }

</style>
